import { connect } from 'react-redux';
import MetoRoom from '../../components/metoRoom/metoRoom';
import * as facultyActions from '../../actions/faculty';
import * as actions from '../../actions/metoRoom';

const mapStateToProps = ({ auth, faculty, metoRoom }) => ({
  facultyList: faculty.list,
  methodical: metoRoom.methodical,
  content: metoRoom.content,
  mid: auth.mid,
});

const mapDispatchToProps = dispatch => ({
  fetchFaculties: () => dispatch(facultyActions.listWithFiles()),
  fetchMethodical: facultyId => dispatch(actions.methodical(facultyId)),
  fetchContent: (facultyId, mrId) => dispatch(actions.content(facultyId, mrId)),
  openFileInTab: (facultyId, mrId, filename) => dispatch(actions.openFile(facultyId, mrId, filename)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MetoRoom);
